"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var category_item_dto_1 = require("../item/dto/category-item-dto");
var category_type_1 = require("../item/type/category-type");
var date_category_type_1 = require("../item/type/date-category-type");
var measure_item_dto_1 = require("../item/dto/measure-item-dto");
var measure_type_1 = require("../item/type/measure-type");
var filter_type_1 = require("../filter/type/filter-type");
var CriterionIntoDTO = /** @class */ (function () {
    function CriterionIntoDTO(filterItem, groupBuilder, expressionTail) {
        if (expressionTail === void 0) { expressionTail = null; }
        this.filterItem = filterItem;
        this.groupBuilder = groupBuilder;
        this.expressionTail = expressionTail;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterItem);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupBuilder);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(expressionTail);
        this.item = null;
    }
    CriterionIntoDTO.prototype.visit = function (criterion) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(criterion);
        var itemDto = this.filterItem.item;
        var filterType = this.filterItem.filterType;
        var expressionTail = null;
        if (itemDto instanceof category_item_dto_1.CategoryItemDto) {
            var categoryType = itemDto.categoryType;
            var dateCategoryType = itemDto.dateCategoryType;
            var item = this.createItem(criterion);
            this.item = item;
            if (categoryType === category_type_1.CategoryType.STANDARD) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.TOP) {
                    expressionTail = item.top(criterion.byMeasureId, criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.CONTAINS || filterType === filter_type_1.FilterType.NOT_CONTAINS) {
                    expressionTail = item.contains(criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.BEGINS_WITH) {
                    expressionTail = item.startsWith(criterion.value);
                }
            }
            else if (categoryType === category_type_1.CategoryType.ME_ASSETS) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    expressionTail = item.in(new Set(criterion.values));
                }
            }
            else if (categoryType === category_type_1.CategoryType.DATE) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        throw new Error('Not implemented!');
                    }
                    else {
                        expressionTail = item.in(new Set(criterion.values));
                    }
                }
                else if (filterType === filter_type_1.FilterType.IS || filterType === filter_type_1.FilterType.IS_NOT) {
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        expressionTail = item.is(criterion.value);
                    }
                    else {
                        throw new Error('Not implemented!');
                    }
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.CURRENT || filterType === filter_type_1.FilterType.NOT_CURRENT) {
                    expressionTail = item.isCurrent();
                }
                else if (filterType === filter_type_1.FilterType.PREVIOUS) {
                    expressionTail = item.isLast(criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.NEXT) {
                    expressionTail = item.isNext(criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        expressionTail = item.between(criterion.valueFrom, criterion.valueTo);
                    }
                    else {
                        expressionTail = item.between(criterion.valueFrom, criterion.valueTo);
                    }
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_BEFORE) {
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        expressionTail = item.onOrBefore(criterion.valueTo);
                    }
                    else {
                        expressionTail = item.onOrBefore(criterion.valueTo);
                    }
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_AFTER) {
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        expressionTail = item.onOrAfter(criterion.valueFrom);
                    }
                    else {
                        expressionTail = item.onOrAfter(criterion.valueFrom);
                    }
                }
            }
            else if (categoryType === category_type_1.CategoryType.USER) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    expressionTail = item.in(new Set(criterion.values));
                }
                else if (filterType === filter_type_1.FilterType.CURRENT_USER) {
                    expressionTail = item.isCurrentUser();
                }
            }
            if (!expressionTail) {
                throw new Error("Unhandled combination of category and filter types (were '" + category_type_1.CategoryType[filterType] + "' and '" + filter_type_1.FilterType[filterType] + "' respectively).");
            }
        }
        else if (itemDto instanceof measure_item_dto_1.MeasureItemDto) {
            var measureType = itemDto.measureType;
            var item = this.createItem(criterion);
            this.item = item;
            if (measureType === measure_type_1.MeasureType.NUMBER) {
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    expressionTail = item.is(criterion.value, null, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    expressionTail = item.between(criterion.valueFrom, criterion.valueTo, null, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN) {
                    expressionTail = item.lessThan(criterion.valueTo, null, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN_OR_EQUALS) {
                    expressionTail = item.lessThanOrEqual(criterion.valueTo, null, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN) {
                    expressionTail = item.greaterThan(criterion.valueFrom, null, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN_OR_EQUALS) {
                    expressionTail = item.greaterThanOrEqual(criterion.valueFrom, null, criterion.byCategoryId);
                }
            }
            else if (measureType === measure_type_1.MeasureType.DATE) {
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    expressionTail = item.is(criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.EMPTY) {
                    throw new Error('Not implemented!');
                }
                else if (filterType === filter_type_1.FilterType.TODAY) {
                    throw new Error('Not implemented!');
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    expressionTail = item.between(criterion.valueFrom, criterion.valueTo);
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_BEFORE) {
                    expressionTail = item.onOrBefore(criterion.valueTo);
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_AFTER) {
                    expressionTail = item.onOrAfter(criterion.valueFrom);
                }
            }
            else if (measureType === measure_type_1.MeasureType.TEXT) {
                if (filterType === filter_type_1.FilterType.CONTAINS || filterType === filter_type_1.FilterType.NOT_CONTAINS) {
                    expressionTail = item.contains(criterion.value);
                }
                else if (filterType === filter_type_1.FilterType.BEGINS_WITH) {
                    expressionTail = item.startsWith(criterion.value);
                }
            }
            else if (measureType === measure_type_1.MeasureType.MONEY) {
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    expressionTail = item.is(criterion.value, criterion.currencyId, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    expressionTail = item.between(criterion.valueFrom, criterion.valueTo, criterion.currencyId, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN) {
                    expressionTail = item.lessThan(criterion.valueTo, criterion.currencyId, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN_OR_EQUALS) {
                    expressionTail = item.lessThanOrEqual(criterion.valueTo, criterion.currencyId, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN) {
                    expressionTail = item.greaterThan(criterion.valueFrom, criterion.currencyId, criterion.byCategoryId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN_OR_EQUALS) {
                    expressionTail = item.greaterThanOrEqual(criterion.valueFrom, criterion.currencyId, criterion.byCategoryId);
                }
            }
            else if (measureType === measure_type_1.MeasureType.BOOLEAN) {
                expressionTail = item.is(criterion.value);
            }
            if (!expressionTail) {
                throw new Error("Unhandled combination of measure and filter types (were '" + measure_type_1.MeasureType[measureType] + "' and '" + filter_type_1.FilterType[filterType] + "' respectively).");
            }
        }
        if (!expressionTail) {
            throw new Error("Unhandled measure type (was '" + itemDto.constructor.name + "').");
        }
        this.expressionTail = expressionTail;
    };
    CriterionIntoDTO.prototype.createItem = function (criterion) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(criterion);
        var itemDto = this.filterItem.item;
        var item = null;
        if (itemDto instanceof category_item_dto_1.CategoryItemDto) {
            if (!this.expressionTail) {
                item = this.groupBuilder.filterByCategory(itemDto.id);
            }
            else {
                item = this.expressionTail.andCategory(itemDto.id);
            }
        }
        else if (itemDto instanceof measure_item_dto_1.MeasureItemDto) {
            if (!this.expressionTail) {
                item = this.groupBuilder.filterByMeasure(itemDto.id);
            }
            else {
                item = this.expressionTail.andMeasure(itemDto.id);
            }
        }
        if (item && criterion.isNegating) {
            item.not();
        }
        return item;
    };
    return CriterionIntoDTO;
}());
exports.CriterionIntoDTO = CriterionIntoDTO;
//# sourceMappingURL=criterion-into-dto.js.map